<template>
  <EarlyAccessBanner>
    <template #text>
      <div class="early-access-cta__text">
        <p class="early-access-cta__title">
          Congratulations — you have early access to our new AI book guides!
        </p>
        <p class="early-access-cta__subtitle">
          We’re working hard on improving content quality. Releasing AI guides
          helps us cover more books earlier, and we believe it’s better to cover
          a book imperfectly than not at all. We plan to revise the guides that
          have the most readers to improve quality.
        </p>

        <p class="early-access-cta__subtitle">
          <router-link :to="{ name: 'help' }">Report problems here</router-link>
          or email us at
          <a href="mailto:help@shortform.com">help@shortform.com</a>
        </p>
      </div>
    </template>
  </EarlyAccessBanner>
</template>

<script setup lang="ts">
import EarlyAccessBanner from '@/app/components/doc/EarlyAccessBanner.vue'
</script>
